"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e, _f, _g;
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertCamelCaseToSnakeCase = exports.getDeployableInfo = exports.getDeviceInfo = exports.getCookie = void 0;
const universal_cookie_1 = __importDefault(require("universal-cookie"));
const analytics_next_1 = require("@segment/analytics-next");
const app_config_1 = __importDefault(require("@nerdwallet/app-config"));
const writeKey = (_a = app_config_1.default === null || app_config_1.default === void 0 ? void 0 : app_config_1.default.SEGMENT) === null || _a === void 0 ? void 0 : _a.WRITE_KEY;
const analytics = analytics_next_1.AnalyticsBrowser.load({
    writeKey,
    cdnURL: (_b = app_config_1.default === null || app_config_1.default === void 0 ? void 0 : app_config_1.default.SEGMENT) === null || _b === void 0 ? void 0 : _b.CDN_URL,
}, {
    cookie: {
        domain: (_c = app_config_1.default === null || app_config_1.default === void 0 ? void 0 : app_config_1.default.SEGMENT) === null || _c === void 0 ? void 0 : _c.DOMAIN,
        maxage: (_d = app_config_1.default === null || app_config_1.default === void 0 ? void 0 : app_config_1.default.SEGMENT) === null || _d === void 0 ? void 0 : _d.MAX_AGE,
        secure: (_e = app_config_1.default === null || app_config_1.default === void 0 ? void 0 : app_config_1.default.SEGMENT) === null || _e === void 0 ? void 0 : _e.SECURE,
    },
    integrations: {
        'Segment.io': {
            apiHost: (_f = app_config_1.default === null || app_config_1.default === void 0 ? void 0 : app_config_1.default.SEGMENT) === null || _f === void 0 ? void 0 : _f.API_HOST,
            protocol: (_g = app_config_1.default === null || app_config_1.default === void 0 ? void 0 : app_config_1.default.SEGMENT) === null || _g === void 0 ? void 0 : _g.PROTOCOL,
        },
    },
});
const cookies = new universal_cookie_1.default();
const getCookie = (cookieName) => cookies.get(cookieName);
exports.getCookie = getCookie;
const getDeviceInfo = () => {
    return {
        traditional_device_id: (0, exports.getCookie)('cookie_id'),
    };
};
exports.getDeviceInfo = getDeviceInfo;
const getDeployableInfo = () => {
    var _a, _b;
    return {
        // eslint-disable-next-line no-underscore-dangle
        deployable_name: (_a = app_config_1.default === null || app_config_1.default === void 0 ? void 0 : app_config_1.default._meta) === null || _a === void 0 ? void 0 : _a.deployable,
        // eslint-disable-next-line no-underscore-dangle
        deployable_version: (_b = app_config_1.default === null || app_config_1.default === void 0 ? void 0 : app_config_1.default._meta) === null || _b === void 0 ? void 0 : _b.version,
    };
};
exports.getDeployableInfo = getDeployableInfo;
const decamelize = (str, separator = '_') => {
    // Regular expression to match lowercase letter followed by uppercase letter
    const regex = /([a-z])([A-Z])/g;
    // $0 represents the matched string
    // $1 represents the lowercase letter
    // $2 represents the uppercase letter
    return str.replace(regex, (_$0, $1, $2) => `${$1}${separator}${$2}`).toLowerCase();
};
/**
 * Utility function to convert object properties from camel case to snake case
 */
// An any is actually useful here; making it unknown would force all supplied objects to extend a Record<string, unknown>
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/ban-ts-comment */
/// @ts-ignore
const convertCamelCaseToSnakeCase = (obj) => {
    if (!obj)
        return obj;
    const snakeCasedObject = {};
    for (const key in obj) {
        const newKey = key.toLowerCase() === 'pageviewid' ? 'pageview_id' : decamelize(key);
        snakeCasedObject[newKey] = obj[key];
    }
    return snakeCasedObject;
};
exports.convertCamelCaseToSnakeCase = convertCamelCaseToSnakeCase;
exports.default = analytics;
